import CloudStorageService from './cloud-storage-service/CloudStorageService';
import ShopAuthService from './shop-auth-service/shopAuthService';
import ShopInfoService from './shop-info-service/shopInfoService';
import AuthStateListener from './users-service/authStateListener';
import ProductsService from './products-service/productsService';
import SupplierService from './supplier-service/supplierService';
import SettingsService from './settings-service/SettingsService';
import MailingService from './mailing-service/MailingService';
import ManagerService from './manager-service/managerService';
import HistoryService from './history-service/HistoryService';
import BoAuthService from './bo-auth-service/boAuthService';
import AuthService from './users-service/authService';
import CartService from './cart-service/CartService';
import PdfService from '../pdf-service/PdfService';
import EdiService from './edi-service/EdiService';
import ADService from './ad-service/ADService';

export default {
  CloudStorageService,
  AuthStateListener,
  ShopAuthService,
  ShopInfoService,
  ProductsService,
  SupplierService,
  SettingsService,
  HistoryService,
  ManagerService,
  MailingService,
  BoAuthService,
  AuthService,
  CartService,
  EdiService,
  PdfService,
  ADService,
};
